import { useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_HREFS } from "../../data/site";
import { useSite } from "../../context/SiteContext";
import { useLang, LangToggle } from "../../i18n/LangContext";
import { Logo, useChannels, useLinks } from "./Brand";

const Ticker = ({ items }) => (
  <div className="overflow-hidden border-b border-[#D4AF37]/20 bg-black py-2" data-testid="header-ticker">
    <div className="ticker flex w-max gap-12 whitespace-nowrap text-xs tracking-wider text-zinc-400">
      {[...items, ...items].map((t, i) => (
        <span key={i} className="flex items-center gap-2">
          <span className="h-1.5 w-1.5 rounded-full bg-[#D4AF37]" />{t}
        </span>
      ))}
    </div>
  </div>
);

export const Header = ({ onJoin }) => {
  const [open, setOpen] = useState(false);
  const { t, lang } = useLang();
  const CHANNELS = useChannels();
  const LINKS = useLinks();
  const { site } = useSite();
  const nav = [...NAV_HREFS.map((href, i) => ({ href, label: t.nav[i] })), ...(site?.blog_count ? [{ href: "/blog", label: lang === "hi" ? "ब्लॉग" : "Blog" }] : [])];
  return (
    <header className="sticky top-0 z-40">
      <Ticker items={t.ticker} />
      <div className="glass border-b border-[#D4AF37]/20">
        <div className="mx-auto flex h-20 max-w-7xl items-center justify-between gap-2 px-3 sm:gap-3 sm:px-6 lg:px-8">
          <Logo />
          <nav className="hidden items-center gap-6 xl:flex">
            {nav.map((n) => (
              <a key={n.href} href={n.href} data-testid={`nav-${n.href.replace(/[/#]/g, "")}`} className="gold-underline whitespace-nowrap text-sm uppercase tracking-widest text-zinc-300 hover:text-white">{n.label}</a>
            ))}
          </nav>
          <div className="flex items-center gap-2 sm:gap-3">
            <LangToggle />
            <div className="hidden items-center gap-2">
              {CHANNELS.map((c) => (
                <a key={c.key} href={c.href} target="_blank" rel="noreferrer" data-testid={`header-${c.key}-link`} aria-label={c.label}
                  className="grid h-9 w-9 place-items-center rounded-full border border-[#D4AF37]/30 text-[#D4AF37] transition-colors hover:border-[#D4AF37] hover:bg-[#D4AF37]/10">
                  <c.icon size={16} />
                </a>
              ))}
            </div>
            <span className="hidden sm:block"><a href={LINKS.login} data-testid="header-login-button" className="btn-outline whitespace-nowrap">{t.header.login}</a></span>
            <button onClick={onJoin} data-testid="header-join-button" className="btn-gold whitespace-nowrap !px-3 !text-[11px] !tracking-wider sm:!px-6 sm:!text-xs sm:!tracking-[0.15em]">{t.header.join}</button>
            <button onClick={() => setOpen(!open)} className="text-[#D4AF37] xl:hidden" data-testid="mobile-menu-toggle" aria-label="Menu">
              {open ? <X /> : <Menu />}
            </button>
          </div>
        </div>
        {open && (
          <nav className="flex flex-col gap-4 border-t border-[#D4AF37]/20 px-6 py-6 xl:hidden" data-testid="mobile-menu">
            {nav.map((n) => (
              <a key={n.href} href={n.href} onClick={() => setOpen(false)} className="text-sm uppercase tracking-widest text-zinc-300">{n.label}</a>
            ))}
            <a href={LINKS.login} data-testid="mobile-login-button" className="btn-outline w-fit">{t.header.login}</a>
          </nav>
        )}
      </div>
    </header>
  );
};
